import { signal } from '@angular/core';
import { FieldTree, SchemaPathTree, required } from '@angular/forms/signals';
import { IdentificationDto } from '../../../core/mceapi.client.generated';


export interface CableDescription {
  uid: string;
  designation: string;
  source: string;
  destination: string;
  description: string;
}

export function buildCableDescriptionSchema(path: SchemaPathTree<CableDescription>) {
  required(path.designation, { message: `Designation is required` });
  required(path.source, { message: `Source is required` });
  required(path.destination, { message: `Destination is required` });
  required(path.description, { message: `Description is required` });
};

export function createCableDescription(uid: string, identification: IdentificationDto) {
  return signal<CableDescription>({
    uid: uid,
    designation: identification.designation ?? '',
    source: identification.source ?? '',
    destination: identification.destination ?? '',
    description: identification.description ?? ''
  });
}

export function createIdentificationDto(description: FieldTree<CableDescription>) {
  return signal<IdentificationDto>({
    designation: description.designation().value(),
    source: description.source().value(),
    destination: description.destination().value(),
    description: description.description().value()
  });
}
